/* eslint-disable max-len */
import { createValues, createValuesBySteps } from './helpers';

const allTypes = 'Tutte le tipologie';
export const filterBtnClass = 'filter-btn';
export const smallBtnCls = `${filterBtnClass} smallbutton`;
export const filterBtnLargeClass = `${filterBtnClass}__multi-l`;
export const filterBtnLargeAllClass = `${filterBtnLargeClass}-all`;

export const valuePriceSell = createValuesBySteps([
  { to: 150000, step: 10000 },
  { to: 300000, step: 25000 },
  { to: 1000000, step: 50000 },
  { to: 2000000, step: 250000 },
  { to: 3000000, step: 500000 },
  { to: 5000000, step: 1000000 },
  { to: 10000000, step: 5000000 },
]);

export const valuePriceRent = createValuesBySteps([
  { to: 1000, step: 50 },
  { to: 2000, step: 100 },
  { to: 10000, step: 500 },
]);

export const valueMqSell = createValuesBySteps([
  { to: 4000, step: 100 },
  { to: 8000, step: 500 },
  { to: 12000, step: 1000 },
], { start: 900 });

const isVisible = () => true;
const getChannel = (f) => f.channel; // vendita | affitti | affitto-breve
const getCategory = (f) => f.propertyTypeGroup || f.category;
const hasPropType = (f, type) => (f.propertyTypes || []).indexOf(type) >= 0;
const hasAllPropTypes = (f) => {
  if (f && f.propertyTypes) {
    return f.propertyTypes.length === 0;
  }
  return false;
};

// Checks types
const isTypeVendita = (f) => getChannel(f) === 'vendita';
const isTypeBreve = (f) => getChannel(f) === 'affitto-breve';
const isTypeAffittoOrBreve = (f) => ['affitti', 'affitto-breve'].indexOf(getChannel(f)) >= 0;

// Checks for categories
const isCase = (f) => getCategory(f) === 'case';
const isCaseAll = (f) => isCase(f) && hasAllPropTypes(f);
const isTerreni = (f) => getCategory(f) === 'terreni';
const isCantine = (f) => getCategory(f) === 'cantine-solai';
const isGarage = (f) => getCategory(f) === 'garage-posti-auto';
const isAttivComm = (f) => getCategory(f) === 'commerciale';
const isAttivCommAll = (f) => isAttivComm(f) && hasAllPropTypes(f);
const isStanzaSingola = (f) => getCategory(f) === 'stanze';
const isNuovaCostruzione = (f) => getCategory(f) === 'nuove-costruzioni';
const isNuovaCostruzioneAll = (f) => isNuovaCostruzione(f) && hasAllPropTypes(f);
const isEdificio = (f) => getCategory(f) === 'edifici-palazzi';
const isCapannone = (f) => getCategory(f) === 'capannoni';
const isUfficio = (f) => getCategory(f) === 'uffici';

// Checks for sub-categories
const hasAppartamento = (f) => hasPropType(f, 'Appartamento');
const hasAttico = (f) => hasPropType(f, 'Attico/mansarda');

const hasBaitaBungalow = (f) => hasPropType(f, 'Baita/bungalow/chalet/trullo');
const hasCasaBiTri = (f) => hasPropType(f, 'Casa bi/trifamiliare');
const hasCasaIndip = (f) => hasPropType(f, 'Casa indipendente');
const hasRustico = (f) => hasPropType(f, 'Rustico/casale');
const hasVilla = (f) => hasPropType(f, 'Villa');
const hasVillaSchiera = (f) => hasPropType(f, 'Villetta a schiera');

const hasLoft = (f) => hasPropType(f, 'Loft');
// const hasPalazzo = (f) => hasPropType(f, 'Palazzo');

// const hasAlbergo = (f) => hasPropType(f, 'Albergo');
// const hasLicenzaComm = (f) => hasPropType(f, 'Attività/licenza commerciale');
// const hasAzAgricola = (f) => hasPropType(f, 'Azienda agricola');
// const hasBar = (f) => hasPropType(f, 'Bar');
// const hasCapannone = (f) => hasPropType(f, 'Capannone');
// const hasLaboratorio = (f) => hasPropType(f, 'Laboratorio');
// const hasLocComm = (f) => hasPropType(f, 'Locale commerciale');
// const hasMagazzino = (f) => hasPropType(f, 'Magazzino');
// // const hasNegozio = (f) => hasPropType(f, 'Negozio');
// const hasRistorante = (f) => hasPropType(f, 'Ristorante');
// const hasShowroom = (f) => hasPropType(f, 'Show room');
// const hasStabilePalazzo = (f) => hasPropType(f, 'Stabile/Palazzo');
// const hasUfficio = (f) => hasPropType(f, 'Ufficio');

const hasAttivitaLicenza = (f) => hasPropType(f, 'Attività/licenza (con o senza mura)');

const hasNoLift = (f) => ![
  isTerreni,
  isGarage,
  isCantine,
  isAttivComm,
  isCapannone,
  hasBaitaBungalow,
  hasCasaBiTri,
  hasCasaIndip,
  hasRustico,
  hasVilla,
  hasVillaSchiera,
].some((fn) => fn(f));

// Common checks
const isNotInTGCP = (f) => ![
  isTerreni,
  isGarage,
  isCantine,
].some((fn) => fn(f));

const isVisibleBalconeTerrazzo = (f) => isCase(f) || isNuovaCostruzione(f);
const isVisibleSoloPiscina = (f) => isCase(f) || isNuovaCostruzione(f);

export const propTypeGroup = {
  component: 'Select',
  defaultValue: 'case',
  defaultDisplay: 'Casa',
  values: [
    ['Casa', 'case', 'Case'],
    ['Nuova costruzione', 'nuove-costruzioni', 'Nuove costruzioni'],
    ['Stanza', 'stanze', 'Stanze'],
    ['Garage o posto auto', 'garage-posti-auto', 'Garage e posti auto'],
    ['Cantina o solaio', 'cantine-solai', 'Cantine e solai'],
    ['Edificio/palazzo', 'edifici-palazzi', 'Edifici/palazzi'],
    ['Ufficio', 'uffici', 'Uffici'],
    ['Immobile o attività commerciale', 'commerciale', 'Immobili o attività commerciali'],
    ['Capannone', 'capannoni', 'Capannoni'],
    ['Terreno', 'terreni', 'Terreni'],
  ].map(([display, value, plural]) => ({
    display,
    value,
    plural,
    count: 0,
  })),
  excludeValues: {
    vacanze: {
      type: 'channel',
      value: 'vendita',
    },
  },
  updates: 'propertyTypes',
  label: 'Categoria',
  humanDefaultValue: 'Casa',
  itemCssClass: 'button nohighlight',
  isVisible,
};

// Values to handle 'affitti-brevi'
export const propTypeGroupValuesRent = [
  {
    display: 'Casa',
    value: 'case-vacanza',
    count: 0,
  },
  ...propTypeGroup.values.slice(1),
];

export const propTypeGroupRent = {
  ...propTypeGroup,
  values: propTypeGroupValuesRent,
};

export const poiConfig = {
  isVisible: (f) => ![isTerreni, isCantine].some((fn) => fn(f)),
};

export const SORT_DEFAULT_LABEL = 'Ordina risultati';
export const SORT_DEFAULT_LABEL_DESKTOP = 'Altro';

export const SORT_VALUES = {
  realEstate: {
    relevance: 'Più rilevanti',
    price_desc: 'Prezzo - dal più alto',
    price_asc: 'Prezzo - dal più basso',
    surface_desc: 'Superficie - dalla maggiore',
    surface_asc: 'Superficie - dalla minore',
    date_desc: 'Data più recente',
    date_asc: 'Data meno recente',
  },
  agencies: {
    default: 'Standard',
    name_asc: 'Dalla A alla Z',
    name_desc: 'Dalla Z alla A',
  },
};

export const LICENSE_CATEGORIES = {
  general: {
    subcategories: [
      ['Bar, pub e caffè', 'bar-pub-caffe', 'Bar, pub e caffè'],
      ['Ristoranti e locali con cucina', 'ristorazione', 'Ristoranti e locali con cucina'],
      ['Negozi', 'negozio', 'Negozi'],
      ['Tabaccheria', 'tabaccheria', 'Tabaccherie'],
      ['Laboratorio', 'laboratorio', 'Laboratori'],
      ['Strutture ricettive', 'struttura-ricettiva', 'Strutture ricettive'],
      ['Centri estetici e parrucchieri', 'estetica-e-bellezza', 'Centri estetici e parrucchieri'],
      ['Altre attività', 'altre-attivita', 'Altre attività'],
    ].map(([display, slug, plural]) => ({
      display,
      value: display,
      slug,
      plural,
    })),
  },
  // ristorazione: {
  //   label: 'Ristorazione e alloggi',
  //   subcategories: [
  //     ['Strutture ricettive', 'struttura-ricettiva', 'Strutture ricettive'],
  //     ['Bar, pub e caffè', 'bar-pub-caffe', 'Bar, pub e caffè'],
  //     ['Ristoranti e locali con cucina', 'ristorazione', 'Ristoranti e locali con cucina'],
  //   ].map(([display, slug, plural]) => ({
  //     display,
  //     value: display,
  //     slug,
  //     plural,
  //   })),
  // },
  // commercio: {
  //   label: 'Commercio',
  //   subcategories: [
  //     ['Negozi di alimentari', 'alimentari', 'Negozi di alimentari'],
  //     ['Tabaccheria', 'tabaccheria', 'Tabaccherie'],
  //     ['Farmacia', 'farmacia', 'Farmacie'],
  //     ['Edicola', 'edicola', 'Edicole'],
  //     ['Negozi di vendita al dettaglio', 'commercio-al-dettaglio', 'Negozi di vendita al dettaglio'],
  //   ].map(([display, slug, plural]) => ({
  //     display,
  //     value: display,
  //     slug,
  //     plural,
  //   })),
  // },
  // servizi: {
  //   label: 'Servizi',
  //   subcategories: [
  //     // ['Centro educativo', 'centri+educativi', 'Centri educativi'],
  //     ['Centri estetici e parrucchieri', 'estetica-e-bellezza', 'Centri estetici e parrucchieri'],
  //     ['Palestre', 'palestra', 'Palestre'],
  //     ['Servizi professionali', 'servizi-professionali', 'Servizi professionali'],
  //     ['Laboratorio', 'laboratorio', 'Laboratori'],
  //     ['Magazzino', 'magazzino', 'Magazzini'],
  //     ['Altre attività', 'altre-attivita', 'Altre attività'],
  //   ].map(([display, slug, plural]) => ({
  //     display,
  //     value: display,
  //     slug,
  //     plural,
  //   })),
  // },
};

export const LICENSE_TYPE_GROUPS = () => {
  const sub = [];
  Object.keys(LICENSE_CATEGORIES).forEach((cat) => sub.push(...LICENSE_CATEGORIES[cat].subcategories));
  return sub;
};

// Filter configuration
export const DEFAULT_FILTERS_CONFIGURATION = {
  zones: {
    component: 'Select', // ReactComponent name
    multiple: true, // multiple choice filter
    defaultValue: ['all'], // default filter value
    values: [], // set of values - list of objects: { display: $string,value: $string,count: $integer}

    // Filter logic
    // dependsOn: null, // does the value/set of values of the filter depend on the value of another filter?
    updates: 'surrounding', // does the value of the filter need to updatethe value/set of values of another filter?

    // Layout configuration
    label: 'Zone / Frazioni', // filter label
    // labelOnly: 'Zone / Frazioni', // filter label
    humanDefaultValue: 'Tutte', // human default value (handle text)
    // humanValueMeasureUnit: '', // filter values measure unit (ie. m² || ° || + || &euro;)
    // containerCssClass: null, // css class to apply to component container for personalization
    // itemCssClass: null, // css class to apply to component elements for personalization
    // isNew: false, // should the filter label have a 'new' tag?
    resetButton: true,
    // Specify conditional rendering based on current selected filters/types/channel/etc.
    // isVisible: (filters) => { return false || true; }
  },

  //   surrounding: {
  //     component: 'Checkbox',
  //     defaultValue: false,
  //     values: [],
  //     dependsOn: 'zones',
  //     label: 'Includi località circostanti',
  //     itemCssClass: 'button nohighlight',
  //     resetButton: true,
  //   },

  category: propTypeGroup,

  channel: {
    component: 'Buttons',
    defaultValue: 'vendita',
    values: [['vendita', 'Vendita'], ['affitti', 'Affitto'], ['affitto-breve', 'Affitto breve'],
    ].map(([value, display]) => ({
      display,
      value,
      count: 0,
    })),
    excludeValues: {
      'vendita': [
        {
          type: 'category',
          value: 'stanze',
        },
      ],
      'affitto-breve': [
        ['nuove-costruzioni'],
        ['terreni'],
        ['commerciale'],
        ['garage-posti-auto'],
        ['stanze'],
        ['cantine-solai'],
        ['uffici'],
        ['capannoni'],
        ['edifici-palazzi'],
      ].map(([value]) => ({
        type: 'category',
        value,
      })),
    },
    label: 'Contratto',
    humanDefaultValue: 'Vendita',
    itemCssClass: `${filterBtnClass} button nohighlight`,
    isVisible,
  },

  propertyTypes: {
    component: 'Select',
    multiple: true,
    defaultValue: [],
    defaultDisplay: [],
    values: {
      'case': [
        [allTypes, 'tutte', allTypes],
        ['Appartamento', 'appartamento', 'Appartamenti'],
        ['Attico/mansarda', 'attico+mansarda', 'Attici/mansarde'],
        ['Baita/bungalow/chalet/trullo', 'baita+bungalow+chalet+trullo', 'Baite/bungalow/chalet/trulli'],
        ['Casa bi/trifamiliare', 'casa+bi+trifamiliare', 'Case bi/trifamiliari'],
        ['Casa indipendente', 'casa+indipendente', 'Case indipendenti'],
        ['Loft', 'loft', 'Loft'],
        ['Rustico/casale', 'rustico+casale', 'Rustici/casali'],
        ['Villa', 'villa', 'Ville'],
        ['Villetta a schiera', 'villetta+a+schiera', 'Villette a schiera'],
      ].map(([display, slug, plural]) => ({
        display,
        value: display,
        slug,
        plural,
        count: 0,
      })),
      'case-vacanza': [
        [allTypes, 'tutte', allTypes],
        ['Appartamento', 'appartamento', 'Appartamenti'],
        ['Attico/mansarda', 'attico+mansarda', 'Attici/mansarde'],
        ['Baita/bungalow/chalet/trullo', 'baita+bungalow+chalet+trullo', 'Baite/bungalow/chalet/trulli'],
        ['Loft', 'loft', 'Loft'],
        ['Rustico/casale', 'rustico+casale', 'Rustici/casali'],
        ['Villa', 'villa', 'Ville'],
        ['Villetta a schiera', 'villetta+a+schiera', 'Villette a schiera'],
      ].map(([display, slug, plural]) => ({
        display,
        value: display,
        slug,
        plural,
        count: 0,
      })),
      'commerciale': [
        [allTypes, 'tutte', allTypes],
        ['Negozio/locale commerciale', 'negozio+locale+commerciale', 'Negozi/locali commerciali'],
        ['Attività/licenza (con o senza mura)', 'attivita+licenza+commerciale', 'Attività/licenze (con o senza mura)'],
      ].map(([display, slug, plural]) => ({
        display,
        value: display,
        slug,
        plural,
        count: 0,
      })),
      'terreni': [
        [allTypes, 'tutte', allTypes],
        ['Terreno agricolo', 'terreno+agricolo', 'Terreni agricoli'],
        ['Terreno edificabile', 'terreno+edificabile', 'Terreni edificabili'],
      ].map(([display, slug, plural]) => ({
        display,
        value: display,
        slug,
        plural,
        count: 0,
      })),
      'stanze': [],
      'nuove-costruzioni': [
        [allTypes, 'tutte', allTypes],
        ['Appartamento', 'appartamento', 'Appartamenti'],
        ['Attico/mansarda', 'attico+mansarda', 'Attici/mansarde'],
        ['Baita/bungalow/chalet/trullo', 'baita+bungalow+chalet+trullo', 'Baita/bungalow/chalet/trullo'],
        ['Casa bi/trifamiliare', 'casa+bi+trifamiliare', 'Case bi/trifamiliari'],
        ['Casa indipendente', 'casa+indipendente', 'Case indipendenti'],
        ['Loft', 'loft', 'Loft'],
        ['Rustico/casale', 'rustico+casale', 'Rustici/casali'],
        ['Villa', 'villa', 'Ville'],
        ['Villetta a schiera', 'villetta+a+schiera', 'Villette a schiera'],
      ].map(([display, slug, plural]) => ({
        display,
        value: display,
        slug,
        plural,
        count: 0,
      })),
      'garage-posti-auto': [],
      'cantine-solai': [],
      'uffici': [],
      'capannoni': [],
      'edifici-palazzi': [],
    },
    excludeValues: {
      altro: {
        'stanza': {
          type: 'channel',
          value: 'vendita',
        },
        'Posto Letto': {
          type: 'channel',
          value: 'vendita',
        },

      },
    },
    dependsOn: 'category',
    label: 'Tipologia',
    humanDefaultValue: allTypes,
    containerCssClass: 'mt--s',
    resetButton: true,
    isVisible,
  },

  license_type_groups: {
    component: 'Select',
    multiple: true,
    defaultValue: [],
    defaultDisplay: [],
    values: LICENSE_TYPE_GROUPS(),
    resetButton: true,
    isVisible: (f) => isAttivComm(f),
  },

  includes_property_ownership: {
    component: 'Buttons',
    defaultValue: 'all',
    values: createValues([['all', 'indifferente'], ['true', 'con mura'], ['false', 'senza mura']]),
    label: 'Tipo di cessione attività',
    humanDefaultValue: 'Indifferente',
    containerCssClass: 'rowsOfOne',
    itemCssClass: `${filterBtnClass} button`,
    resetButton: true,
    isVisible: (f) => isAttivComm(f) && (isAttivCommAll(f) || hasAttivitaLicenza(f)),
    hasIcon: true,
  },

  numRooms: {
    component: 'DnDSlider',
    defaultValue: [0, 100],
    defaultMinValue: 'all',
    defaultMaxValue: 'all',
    values: createValues([
      ['all', 'qualsiasi'],
      ['1'], ['2'], ['3'], ['4'], ['5'], ['6'], ['7'], ['8'],
    ]),
    label: 'Locali - numero minimo',
    labelOnly: 'Locali',
    humanDefaultValue: '- -',
    itemCssClass: `${smallBtnCls} ${filterBtnLargeClass}`,
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => !isTerreni(f) && !isCantine(f) && !isGarage(f) && !isEdificio(f) && !isUfficio(f),
  },

  numBaths: {
    component: 'Buttons',
    defaultValue: 'all',
    values: createValues([['all', 'qualsiasi'], ['1'], ['2'], ['3'], ['4'], ['5']]),
    label: 'Bagni - numero minimo',
    labelOnly: 'Bagni',
    humanDefaultValue: 'Qualsiasi',
    humanValueMeasureUnit: '+',
    itemCssClass: `${smallBtnCls} ${filterBtnLargeClass}`,
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => isNotInTGCP(f) && !isEdificio(f),
  },

  numParkingSpaces: {
    component: 'Buttons',
    defaultValue: 'all',
    values: createValues([['all', 'qualsiasi'], ['1'], ['2'], ['3']]),
    label: 'Box/posti auto - numero minimo',
    labelOnly: 'Box/posti auto',
    humanDefaultValue: 'Qualsiasi',
    humanValueMeasureUnit: '+',
    itemCssClass: smallBtnCls,
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => isNotInTGCP(f) && !isStanzaSingola(f),
  },

  garden: {
    component: 'MultipleButtons',
    multiple: true,
    defaultValue: ['all'],
    values: createValues([['all', 'qualsiasi'], ['comune'], ['privato']]),
    label: 'Giardino',
    humanDefaultValue: 'Qualsiasi',
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => isNotInTGCP(f) && !isAttivComm(f) && !isUfficio(f) && !isCapannone(f) && !isStanzaSingola(f),
  },

  balconyAndTerrace: {
    component: 'MultipleButtons',
    multiple: true,
    defaultValue: ['all'],
    values: createValues([['all', 'qualsiasi'], ['balcone'], ['terrazzo']]),
    label: 'Balcone / terrazzo',
    humanDefaultValue: 'Qualsiasi',
    resetButton: true,
    hasIcon: true,
    isVisible: isVisibleBalconeTerrazzo,
  },

  sellerType: {
    component: 'Buttons',
    // multiple: true,
    defaultValue: ['all'],
    values: createValues([['all', 'qualsiasi'], ['agenzie'], ['privati']]),
    label: 'Tipo di inserzionista',
    humanDefaultValue: 'Qualsiasi',
    containerCssClass: 'rowsOfOne',
    itemCssClass: `${filterBtnClass} button`,
    resetButton: true,
    isVisible,
  },

  level: {
    component: 'TwoLevelsButtons',
    defaultValue: 'all',
    values: {
      main: createValues([['all', 'qualsiasi'], ['piano terra', 'terra'], ['intermedio'], ['ultimo'], ['other', 'almeno:']]),
      additional: createValues([['1'], ['2'], ['3'], ['4'], ['5']]),
    },
    label: 'Piano',
    humanDefaultValue: 'Qualsiasi',
    humanValueMeasureUnit: '°',
    itemCssClass: filterBtnLargeAllClass,
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => ![isTerreni, isGarage, isCantine, isEdificio, isCapannone].some((fn) => fn(f))
      && (
        !isCase(f)
        || isCaseAll(f)
        || (
          isCase(f)
          && [hasAppartamento, hasAttico, hasLoft].some((fn) => fn(f))
        )
      )
      && (
        !isNuovaCostruzione(f)
        || isNuovaCostruzioneAll(f)
        || (
          isNuovaCostruzione(f)
          && [hasAppartamento, hasAttico, hasLoft].some((fn) => fn(f))
        )
      )
      && !isAttivComm(f),
  },

  lift: {
    component: 'TwoLevelsButtons',
    defaultValue: 'all',
    values: {
      main: createValues([['all', 'non importa'], ['false', 'no'], ['true', 'si'], ['other', 'si,se il piano è almeno:']]),
      additional: createValues([['1'], ['2'], ['3'], ['4'], ['5']]),
    },
    label: 'Ascensore',
    humanDefaultValue: 'Non importa',
    humanValueMeasureUnit: '°',
    itemCssClass: filterBtnLargeAllClass,
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => hasNoLift(f),
  },

  commercial_building_location: {
    component: 'MultipleButtons',
    optionsStatic: true,
    defaultValue: ['all'],
    values: createValues([['all', 'qualsiasi'], ['piano-terra', 'piano terra'], ['piano-rialzato', 'piano rialzato'], ['piano-interrato', 'piano interrato'], ['in-centro-commerciale', 'in centro commerciale']]),
    label: 'Ubicazione/posizione',
    humanDefaultValue: 'Qualsiasi',
    itemCssClass: `${filterBtnClass} button`,
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => isAttivComm(f),
  },

  heatingType: {
    component: 'MultipleButtons',
    multiple: true,
    defaultValue: ['all'],
    values: createValues([['all', 'qualsiasi'], ['centralizzato'], ['autonomo']]),
    label: 'Riscaldamento',
    humanDefaultValue: 'Qualsiasi',
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => isNotInTGCP(f) && !isUfficio(f) && !isEdificio(f),
  },

  availability: {
    component: 'Select',
    optionsStatic: true,
    defaultValue: 'all',
    values: createValues([['all', 'qualsiasi'], ['occupato'], ['libero'], ['nuda proprieta'], ['affittato']]),
    label: 'Stato al rogito',
    humanDefaultValue: 'Qualsiasi',
    itemCssClass: `${filterBtnClass} button`,
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => !isTypeAffittoOrBreve(f) && !hasAttivitaLicenza(f),
  },

  publication_date: {
    component: 'Select',
    optionsStatic: true,
    defaultValue: 'all',
    values: createValues([['all', 'qualsiasi'], ['2d', 'ultime 48 ore'], ['7d', 'ultima settimana'], ['30d', 'ultimo mese']]),
    label: 'Data di pubblicazione',
    humanDefaultValue: 'Qualsiasi',
    itemCssClass: `${filterBtnClass} button`,
    resetButton: true,
    isVisible,
  },

  buildingCondition: {
    component: 'MultipleButtons',
    multiple: true,
    defaultValue: ['all'],
    values: createValues([
      ['all', 'qualsiasi'],
      ['nuovo-ristrutturato', 'nuovo/ottimo'],
      ['abitabile', 'buono/abitabile'],
      ['da-ristrutturare', 'da ristrutturare'],
    ]),
    label: 'Condizioni immobile',
    humanDefaultValue: 'Qualsiasi',
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => isNotInTGCP(f) && ![isStanzaSingola, isNuovaCostruzione].some((fn) => fn(f)),
  },

  energyClass: {
    component: 'Buttons',
    defaultValue: 'all',
    values: createValues([['all', 'qualsiasi'], ['G'], ['F'], ['E'], ['D'], ['C'], ['B'], ['A', 'a o sup.']]),
    label: 'Classe energetica minima',
    labelOnly: 'Classe energetica',
    humanDefaultValue: 'Qualsiasi',
    containerCssClass: 'energyClass',
    itemCssClass: `${filterBtnClass} button`,
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => isNotInTGCP(f) && !isStanzaSingola(f),
  },

  mq: {
    component: 'DnDSlider',
    defaultValue: [0, 100],
    defaultMinValue: 'all',
    defaultMaxValue: 'all',
    values: createValuesBySteps([
      { to: 200, step: 10 },
      { to: 1000, step: 50 },
      { to: 10000, step: 500 },
    ]),
    label: 'Metri quadri',
    humanDefaultValue: '- -',
    humanValueMeasureUnit: 'm²',
    resetButton: true,
    hasIcon: true,
    isVisible,
  },

  buildingYear: {
    component: 'DnDSlider',
    defaultValue: [0, 100],
    defaultMinValue: 'all',
    defaultMaxValue: 'all',
    values: createValuesBySteps([
      { to: 2010, step: 10 },
      { to: 2015, step: 5 },
    ], { start: 1840, noEmpty: true }),
    label: 'Anno di costruzione',
    humanDefaultValue: '- -',
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => isNotInTGCP(f) && !isTypeBreve(f),
  },

  priceType: {
    component: 'Buttons',
    defaultValue: 'price',
    values: createValues([['price', 'totale'], ['mqprice', 'al m²'], ['payment', 'rata mutuo']]),
    label: 'Prezzo',
    humanDefaultValue: 'Totale',
    containerCssClass: 'air',
    itemCssClass: `${filterBtnClass} button nohighlight`,
    disableFromConf: false,
    isVisible: (f) => !isAttivCommAll(f) && !hasAttivitaLicenza(f),
  },

  price: {
    component: 'DnDSlider',
    defaultValue: [0, 100],
    defaultMinValue: 'all',
    defaultMaxValue: 'all',
    values: {
      'vendita': valuePriceSell,
      'affitti': valuePriceRent,
      'affitto': valuePriceRent,
      'affitto-breve': valuePriceRent,
    },
    dependsOn: 'channel',
    label: 'Prezzo',
    humanDefaultValue: '- -',
    humanValueMeasureUnit: '€',
    containerCssClass: 'forPrice',
    resetButton: true,
    hasIcon: true,
    disableFromConf: false,
    isVisible,
  },

  mqprice: {
    component: 'DnDSlider',
    defaultValue: [0, 100],
    defaultMinValue: 'all',
    defaultMaxValue: 'all',
    values: {
      'vendita': valueMqSell,
      'affitti': valueMqSell,
      'affitto-breve': valueMqSell,
    },
    dependsOn: 'channel',
    label: 'Prezzo',
    humanDefaultValue: '- -',
    humanValueMeasureUnit: '€',
    containerCssClass: 'forPrice',
    resetButton: true,
    hasIcon: true,
    disableFromConf: false,
    isVisible,
  },

  payment: {
    component: 'DnDSlider',
    defaultValue: [0, 100],
    defaultMinValue: 'all',
    defaultMaxValue: 'all',
    values: {
      'vendita': valuePriceRent,
      'affitti': valuePriceRent,
      'affitto-breve': valuePriceRent,
    },
    dependsOn: 'channel',
    label: 'Prezzo',
    labelOnl: 'Prezzo',
    humanDefaultValue: '- -',
    humanValueMeasureUnit: '€',
    containerCssClass: 'forPrice',
    resetButton: true,
    hasIcon: true,
    disableFromConf: false,
    isVisible,
  },

  photo: {
    component: 'Checkbox',
    defaultValue: false,
    values: [],
    label: 'Solo annunci con foto',
    resetButton: true,
    noaccordion: true,
    isVisible,
  },

  newBuilding: {
    component: 'Checkbox',
    defaultValue: false,
    values: [],
    label: 'Solo nuove costruzioni',
    itemCssClass: 'nomartop',
    resetButton: true,
    isVisible,
  },

  furniture: {
    component: 'MultipleButtons',
    multiple: true,
    defaultValue: ['all'],
    values: createValues([
      ['all', 'qualsiasi'], ['none', 'non arredato'], ['partially', 'parzialmente arredato'], ['full', 'arredato'],
    ]),
    label: 'Arredamento',
    humanDefaultValue: 'Qualsiasi',
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => isNotInTGCP(f) && !isAttivComm(f) && !isUfficio(f) && !isCapannone(f) && !isEdificio(f),
  },

  air_conditioned: {
    component: 'Checkbox',
    defaultValue: false,
    values: [],
    label: 'Solo con aria condizionata',
    itemCssClass: 'nomartop',
    noaccordion: true,
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => isNotInTGCP(f) && !isEdificio(f),
  },

  exclude_under_construction: {
    component: 'Checkbox',
    defaultValue: false,
    values: [],
    label: 'Escludi immobili in costruzione',
    noaccordion: true,
    hasIcon: true,
    isVisible: (f) => isCase(f) && !isTypeAffittoOrBreve(f),
  },

  is_lux: {
    component: 'Checkbox',
    defaultValue: false,
    values: [],
    label: 'Solo immobili di prestigio',
    noaccordion: true,
    hasIcon: true,
    isVisible: (f) => isTypeVendita(f) && isCase(f),
  },

  has_swimming_pool: {
    component: 'Checkbox',
    defaultValue: false,
    values: [],
    label: 'Solo con piscina',
    noaccordion: true,
    hasIcon: true,
    isVisible: (f) => isVisibleSoloPiscina(f),
  },

  has_reception: {
    component: 'Checkbox',
    defaultValue: false,
    values: [],
    label: 'Solo con portineria',
    noaccordion: true,
    hasIcon: true,
    isVisible: (f) =>
      // Hidden in case of these categories
      // eslint-disable-next-line implicit-arrow-linebreak
      ![isTerreni, isCantine, isGarage, isUfficio, isCapannone, isEdificio, isStanzaSingola, isAttivComm].some((fn) => fn(f)),
  },

  exclude_private_negotiation: {
    component: 'Checkbox',
    defaultValue: false,
    values: [],
    label: 'Escludi trattative riservate',
    disableFromConf: false,
    isVisible,
  },
  only_private_negotiation: {
    component: 'Checkbox',
    defaultValue: false,
    values: [],
    label: 'Solo trattative riservate',
    isVisible,
    disableFromConf: false,
  },
  is_auction: {
    component: 'Buttons',
    defaultValue: 'all',
    values: createValues([['all', 'indifferente'], [true, 'solo aste'], [false, 'escludi aste']]),
    label: 'Aste',
    humanDefaultValue: 'Indifferente',
    itemCssClass: smallBtnCls,
    resetButton: true,
    hasIcon: true,
    isVisible: (f) => !isTypeAffittoOrBreve(f) && !hasAttivitaLicenza(f),
  },
  // exclude_auction: {
  //   component: 'Checkbox',
  //   defaultValue: false,
  //   values: [],
  //   label: 'Escludi aste',
  //   noaccordion: true,
  //   hasIcon: true,
  //   isVisible: (f) => !isTypeAffittoOrBreve(f),
  // },

  has_virtual_tour: {
    component: 'Checkbox',
    defaultValue: false,
    values: [],
    label: 'Solo con visita guidata',
    noaccordion: true,
    isVisible,
  },
};

export default DEFAULT_FILTERS_CONFIGURATION;
